module.exports = __webpack_public_path__ + "static/media/icon-hand-white.41034915.svg";